export default {
    light: {
        primary: '#333333',
        secondary: '#032e5a',
        background: '#E2E9F0',
        accent: '#468fcd',
        info: '#d7e0eb',
        'info-contrast': '#C0D1E5',
        error: '#C3151A',
        'error-lighten1': '#e18a8c',
        warning: '#f39152',
        'warning-lighten1': '#f9c8a8',
        success: '#129146',
        'success-lighten1': '#88c8a2',
        regular: '#626165',
        selection: '#268fd3',
        popup_form: '#f4f6f7',
        toggle_bg: '#d3d9e4',
        error_bg: '#efc0c0',
        error_text: '#414142',
        'tab-text': '#6FA7D7',
        'tab-bar': '#EFF4F9',
        'field-border-color': '#468fcd',
        'scrollbar-color': '#d7e0eb'
    }
};
